// <a-text> using `definePrimitive` helper.
var definePrimitive = require('../primitives').definePrimitive;
definePrimitive('a-text', {text: {anchor: 'align', width: 5}});



// WEBPACK FOOTER //
// ./node_modules/aframe/src/extras/primitives/primitives/a-text.js